import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { 
  Box, 
  Container, 
  CircularProgress,
  Typography
} from '@mui/material';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import '../assets/css/futuristic-modern.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        // Redirect to signin with error
        console.log('❌ No token provided, redirecting to signin');
        window.location.href = '/signin?verification=error&message=Invalid verification link';
        return;
      }
      
      // Set a fallback timeout - if verification takes more than 10 seconds, redirect anyway
      const fallbackTimeout = setTimeout(() => {
        console.log('⏱️ Verification timeout reached, redirecting to signin');
        window.location.href = '/signin?verification=error&message=Verification timed out. Please try again.';
      }, 10000);
      
      try {
        console.log('🔄 Starting email verification with token:', token.substring(0, 10) + '...');
        
        // Add timeout to axios request
        const response = await axios.get(`${API_BASE_URL}/api/verify-email?token=${token}`, {
          timeout: 8000 // 8 second timeout
        });
        
        clearTimeout(fallbackTimeout); // Cancel fallback if successful
        console.log('✅ Email verification successful:', response.data);
        
        // Use window.location.href for more reliable redirect in production
        setTimeout(() => {
          console.log('🔄 Redirecting to signin...');
          window.location.href = '/signin?verification=success';
        }, 500);
      } catch (error) {
        clearTimeout(fallbackTimeout); // Cancel fallback since we got a response
        console.error('❌ Email verification failed:', error);
        
        const errorMessage = error.response?.data?.error || error.message || 'Verification failed';
        console.log('🔄 Redirecting to signin with error...');
        
        // Use window.location.href for more reliable redirect
        setTimeout(() => {
          window.location.href = `/signin?verification=error&message=${encodeURIComponent(errorMessage)}`;
        }, 500);
      }
    };
    
    verifyEmail();
  }, [searchParams, navigate]);
  
  // Show loading state while verifying
  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        background: 'var(--surface)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress 
            size={60}
            thickness={4}
            sx={{ color: 'var(--neon-cyan)', mb: 2 }} 
          />
          <Typography 
            variant="h6" 
            sx={{ color: 'var(--text-muted)' }}
          >
            Verifying your email...
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default VerifyEmail;
